import { combineReducers, ReducersMapObject } from 'redux';
import { Action } from '../actions';
import { AppState } from '../models/state/appState';
import availableTelsReducer from './availableTelsReducer';
import bundleAlertDefinitionsReducer from './bundleAlertDefinitionsReducer';
import commandDefinitionsReducer from './commandDefinitionsReducer';
import commandTypesReducer from './commandTypesReducer';
import filterSettingsReducer from './filterSettingsReducer';
import gridReducer from './gridReducer';
import loginReducer from './loginReducer';
import notificationReducer from './notificationReducer';
import mvnoTemplatesReducer from './mvnoTemplatesReducer';
import portNetworkReducer from './portNetworksReducer';
import simProvisionReducer from './simProvision/index';
import simReducer from './simReducer';
import submissionReducer from './submissionReducer';
import submissionsReducer from './submissionsReducer';
import userCommandTypesReducer from './userCommandTypesReducer';
import userRolesReducer from './userRolesReducer';
import userSettingsReducer from './userSettingsReducer';
import mvnoBundleReducer from './mvnoBundleReducer';

const reducers: ReducersMapObject<AppState, any> = {
    mvnoTemplates: mvnoTemplatesReducer,
    mvnoBundle: mvnoBundleReducer,
    availableTels: availableTelsReducer,
    bundleAlertDefinitions: bundleAlertDefinitionsReducer,
    commandDefinitions: commandDefinitionsReducer,
    commandTypes: commandTypesReducer,
    loginDetails: loginReducer,
    filter: filterSettingsReducer,
    grid: gridReducer,
    notifications: notificationReducer,
    portNetworks: portNetworkReducer,
    sims: simReducer,
    simProvisionState: simProvisionReducer,
    submission: submissionReducer,
    submissions: submissionsReducer,
    userCommandTypes: userCommandTypesReducer,
    userRoles: userRolesReducer,
    userSettings: userSettingsReducer,
};

const rootReducer = (state: AppState | undefined, action: Action<any>): AppState => {
  return combineReducers(reducers)(state, action);
};

export default rootReducer;
